
import NavBar from '../../components/feature/NavBar';
import Contact from '../home/components/Contact';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const contactJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Contact ZJF IT Services LLC | IT Deployment New York',
    description: 'Get in touch with ZJF IT Services LLC for IT deployment projects in New York and nationwide. We respond within 24 hours.',
    url: `${siteUrl}/contact`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Contact', item: `${siteUrl}/contact` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact ZJF IT Services LLC',
    url: `${siteUrl}/contact`,
    mainEntity: {
      '@type': 'LocalBusiness',
      name: 'ZJF IT Services LLC',
      telephone: '+19737504968',
      email: 'info@zjfitservices.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'New York',
        addressRegion: 'NY',
        addressCountry: 'US',
      },
    },
  },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="Contact ZJF IT Services LLC | IT Deployment New York"
        description="Get in touch with ZJF IT Services LLC for IT deployment projects in New York and nationwide. We respond to all inquiries within 24 hours."
        keywords="contact ZJF IT Services, IT deployment inquiry New York, IT project consultation NYC, reach IT specialists"
        canonical={`${siteUrl}/contact`}
        jsonLd={contactJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">Reach Out</span>
          <h1 className="text-5xl font-bold text-white mb-4">Contact Us</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Ready to discuss your IT deployment project? We respond within 24 hours.
          </p>
        </div>
        <Contact />
      </div>
    </div>
  );
}
